import React, { Component } from "react";
import { MdOutlineDeleteOutline } from "react-icons/md";
import { FaRegEdit } from "react-icons/fa";
import axios from "axios";
import { FaRegSadTear } from "react-icons/fa"

class CourseProcedure extends Component {
    state = {
        updatedtitle: '',
        isEditingtitle: false,
        updateddescription: '',
        isEditingdescription: false,
        editingParagraphIndex: null,
        editingId: null,
        course: [],
        parseDescriptions: {},
        editingStepId: null,
        
    }
    inputRef = React.createRef();
    descriptionRef = React.createRef();

    handleAddprocedure = () => {
        const formcontainer = document.querySelector(".dash_add_course_cover.addsteps")
        formcontainer.style.display = "flex"
    }

    componentDidMount() {
        this.fetchCourses();
    }

    componentDidUpdate(prevProps) {
        if (this.props.shouldRefresh && this.props.shouldRefresh !== prevProps.shouldRefresh) {
            this.fetchCourses();
            this.props.onRefreshDone(); // Important: Call the callback to reset the flag
        }
    }
    fetchCourses = async () => {
        const accessToken = localStorage.getItem("accessToken");

        try {
            const course_id = this.props.course_id
            const courseId = parseInt(course_id, 10);
            const response = await axios.get("https://api.geoinfoacademy.com/api/tutor/courses/" + courseId, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });
            this.setState({ course: response.data });
            const parsedDescriptions = {}; // Initialize an object to store parsed descriptions
            response.data.step_by_step.forEach(step => {
                if (step.description) {
                    parsedDescriptions[step.id] = this.parseDescription(step.description); // Store parsed descriptions by step ID
                }
            });
            this.setState({ parsedDescriptions: parsedDescriptions });

            console.log("API Response:", response.data);
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };
    parseDescription = (text) => {
        if (!text) {
            return [];
        }

        const lines = text.split('\n');
        return lines
            .filter((line) => line.trim().startsWith('#'))
            .map((line, index) => {
                const trimmedLine = line.trim().substring(1).trim();
                return {
                    id: (index + 1).toString(),
                    paragraph: trimmedLine,
                };
            });
    };

    handleDelete = async (steps) => {
        const accessToken = localStorage.getItem("accessToken");


        try {
            const response = await axios.delete(`https://api.geoinfoacademy.com/api/tutor/step-by-step/${steps.id}/`, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });

            if (response.status === 204 || response.status === 200) { // Check for successful delete status codes (204 No Content is common)
                console.log("Document deleted successfully:", steps.id);
                // Optionally: Refresh the document list after successful deletion
                this.fetchCourses(); // Or whatever method you use to refresh the list
                // You might also want to provide user feedback (e.g., a toast notification)
                // alert("Document deleted successfully")
            } else {
                console.error("Error deleting document:", response.status, response.data);
                // Handle error (e.g., display an error message to the user)
                alert("Error deleting document")

            }
        } catch (error) {
            console.error("Error deleting document:", error);
            // Handle network errors or other exceptions
            alert("Error deleting document")
        }
    };


    // handle the changes of the header and paragraph 
    handleInputChange = (e, field, index) => {
        // if (field === 'description') {
        //     const updatedDescriptions = [...this.state.updateddescription];
        //     updatedDescriptions[index] = e.target.value;
        //     this.setState({ updateddescription: updatedDescriptions });
        // } else {
        //     this.setState({ [`updated${field}`]: e.target.value });
        // }
        this.setState({ [`updated${field}`]: e.target.value });
    };

    // Toggle editing for other fields
    toggleEditing = (field, id, stepId) => {
        if (field === 'description') {
            const step = this.state.course.step_by_step.find(s => s.id === stepId);
            if (step) {
                this.setState({
                    isEditingdescription: true,
                    editingId: id,
                    updateddescription: step.description,
                    editingStepId: stepId,
                });
            }
        } else {
            const stepByStep = this.state.course && this.state.course.step_by_step;
            if (stepByStep) {
                const itemToEdit = stepByStep.find(item => item.id === id);
                if (itemToEdit) {
                    this.setState({
                        [`isEditing${field}`]: true,
                        editingId: id,
                        [`updated${field}`]: itemToEdit[field],
                    });
                }
            }
        }
    };

    handleKeyDown = (event, field, id) => {
        if (event.key === 'Enter') {
            this.submitChanges(field, id);
        }
    };
    submitChanges = (field, id) => {
        const accessToken = localStorage.getItem("accessToken");
        // if (field === 'description') {
        //     const step = this.state.course.step_by_step.find(s => s.description.some(p => p.id === id));
        //     if (step) {
        //         const updatedDescription = [...step.description];
        //         updatedDescription[this.state.editingParagraphIndex].paragraph = this.state.updateddescription[this.state.editingParagraphIndex];
        //         const updatedStep = {
        //             ...step,
        //             description: updatedDescription,
        //         };
        if (field === 'description') {
            const step = this.state.course.step_by_step.find(s => s.id === this.state.editingStepId);
            if (step) {
                const updatedStep = {
                    ...step,
                    description: this.state.updateddescription,
                };
                fetch(`https://api.geoinfoacademy.com/api/tutor/step-by-step/${step.id}/`, {
                    method: 'PATCH',
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(updatedStep),
                })
                    .then(response => {
                        if (!response.ok) {
                            throw new Error('Network response was not ok');
                        }
                        return response.json();
                    })
                    .then(data => {
                        this.fetchCourses();
                        this.setState({ isEditingdescription: false, editingParagraphIndex: null });
                    })
                    .catch(error => {
                        console.error('There has been a problem with your fetch operation:', error);
                    });
            }
        } else {
            // ... (Your existing title update logic)
            const stepToUpdate = this.state.course.step_by_step.find(step => step.id === id);
            if (!stepToUpdate) {
                console.error("Step not found for update.");
                return;
            }
            const updatedStep = {
                ...stepToUpdate,
                [field]: this.state[`updated${field}`],
            };
            fetch(`https://api.geoinfoacademy.com/api/tutor/step-by-step/${id}/`, {
                method: 'PATCH',
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(updatedStep),
            })
                .then(response => {
                    if (!response.ok) {
                        throw new Error('Network response was not ok');
                    }
                    return response.json();
                })
                .then(data => {
                    this.fetchCourses();
                    this.setState({
                        updatedtitle: '',
                        isEditingtitle: false,
                    });
                    console.log('Course updated successfully:', data);
                })
                .catch(error => {
                    console.error('There has been a problem with your fetch operation:', error);
                });
            this.setState({ isEditing: false });
        }
    };

    render() {
        console.log("i want to check",this.state.parseDescription)
        const procedure = this.state.course
        // const steps = procedure && procedure.step_by_step && procedure.step_by_step.length ? (
        //     procedure.step_by_step.map((steps) => {
        //         return (
        //             <div className="course_procedure_cover" key={steps.id}>
        //                 <button className="edit" onClick={() => this.handleDelete(steps)}><MdOutlineDeleteOutline /></button>

        //                 {/* Interval */}
        //                 {this.state.isEditingtitle ? (
        //                     <input
        //                         type="text"
        //                         value={this.state.updatedtitle}
        //                         onChange={(e) => this.handleInputChange(e, 'title')}
        //                         ref={this.inputRef}
        //                         onBlur={() => this.submitChanges('title',steps.id)}
        //                         onKeyDown= {(event) => this.handleKeyDown(event, 'title', steps.id)}
        //                     />
        //                 ) : (
        //                     <h4>{steps.title} <button className="edits" onClick={() => this.toggleEditing('title', steps.id)}><FaRegEdit /></button></h4>
        //                 )}
        //                 {this.state.isEditingdescription ? (
        //                     <input
        //                         type="text"
        //                         value={this.state.updateddescription}
        //                         onChange={(e) => this.handleInputChange(e, 'description')}
        //                         ref={this.descriptionRef}
        //                         onBlur={() => this.submitChanges('description', steps.id)}
        //                         onKeyDown= {(event) => this.handleKeyDown(event, 'description', steps.id)}
        //                         className="last"
        //                     />
        //                 ) : (
        //                     <p>{steps.description}<button className="edits" onClick={() => this.toggleEditing('description', steps.id)}><FaRegEdit /></button> </p>
        //                 )}

        //                 {/* <h4>{steps.title}</h4>
        //                 <p>{steps.description}</p> */}
        //             </div>
        //         );
        //     })
        // ) : (
        //     <div className="enroll_error">
        //             <div className="enroll_cover">
        //                  <FaRegSadTear />
        //                  <p>The Course doesn't come with any thing</p>
        //              </div>
        //          </div>
        // );



        // const procedure = this.state.course;
        const steps =
            procedure && procedure.step_by_step && procedure.step_by_step.length ? (
                procedure.step_by_step.map((step) => {
                    return (
                        <div className="course_procedure_cover" key={step.id}>
                            <button className="edit" onClick={() => this.handleDelete(step)}><MdOutlineDeleteOutline /></button>
                            {this.state.isEditingtitle ? (
                                <input
                                    type="text"
                                    value={this.state.updatedtitle}
                                    onChange={(e) => this.handleInputChange(e, 'title')}
                                    ref={this.inputRef}
                                    onBlur={() => this.submitChanges('title', step.id)}
                                    onKeyDown={(event) => this.handleKeyDown(event, 'title', step.id)}
                                />
                            ) : (
                                <h4>{step.title} <button className="edits" onClick={() => this.toggleEditing('title', step.id)}><FaRegEdit /></button></h4>
                            )}
                            {this.state.isEditingdescription && this.state.editingStepId === step.id ? (
                                <textarea
                                    value={this.state.updateddescription}
                                    onChange={(e) => this.handleInputChange(e, 'description')}
                                    ref={this.descriptionRef}
                                    onBlur={() => this.submitChanges('description', step.id)}
                                    className="last"
                                />
                            ) : (
                                <div>
                                    {this.state.parsedDescriptions[step.id] && this.state.parsedDescriptions[step.id].map(paragraphObj => (
                                        <p key={paragraphObj.id}>
                                            {paragraphObj.paragraph}
                                        </p>
                                    ))}
                                    <button className="edits" onClick={() => this.toggleEditing('description', step.id, step.id)}><FaRegEdit /></button>
                                </div>
                            )}
                        </div>

                           
                    );
                })
            ) : (
                <div className="enroll_error">
                    <div className="enroll_cover">
                        <FaRegSadTear />
                        <p>The Course doesn't come with any thing</p>
                    </div>
                </div>
            );



        return (
            <section className="course_procedure">
                <h3>Course Contents <button onClick={this.handleAddprocedure} className="add">Add content</button></h3>
                {steps}
            </section>
        )
    }
}


export default CourseProcedure